(function () {
  const $videoBlocks = $('.video-hero-block');

  // Change video src to landscape if device width is larger than 576px
  if ($(window).width() > 576 && $videoBlocks.length > 0) {
    $videoBlocks.each(function (i, obj) {
      var $video = $(this).find('video')[0],
          $source = $($video).find('source'),
          landscapeLoop = $source.data('landscape-loop'),
          landscapeFull = $source.data('landscape-full');

      $video.pause();
      $source.attr('src', landscapeLoop);
      $source.attr('data-full', landscapeFull);
      $source.attr('data-loop', landscapeLoop);
      $video.load();
      // video.play();
    });
  }

  // Change video src when device changes orientation
  window.addEventListener('orientationchange', function (event) {
    var windowOrientation = event.target.screen.orientation.type;
    updateHeroVideos(windowOrientation);
  }, false);

  function updateHeroVideos(orientation) {
    $videoBlocks.each(function (i, obj) {
      var $video = $(this).find('video')[0],
          $source = $($video).find('source'),
          full, loop;

      if (orientation === 'landscape-primary') {
        loop = $source.data('landscape-loop');
        full = $source.data('landscape-full');
      } else if (orientation === 'portrait-primary') {
        loop = $source.data('portrait-loop');
        full = $source.data('portrait-full');
      }

      $video.pause();
      $source.attr('src', loop);
      $source.attr('data-full', full);
      $source.attr('data-loop', loop);
      $video.load();
      // video.play();
    });
  }

  if ($('.video-hero-anchor').length) {
    $('.video-hero-anchor').on('click', function (e) {
      e.preventDefault();
      var sectionHeight = $(this).closest('.trend-video-header-wrap').height(),
          sectionOffset = $(this).closest('.trend-video-header-wrap').offset().top;

      $('html, body').animate({
        scrollTop: sectionOffset + sectionHeight
      }, 1000);
    });
  }

  let options = {
    root: null
  };

  const videoBlockObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(({ intersectionRatio, target }) => {
        const $video = target.querySelector('video');

        if (intersectionRatio > 0 && $video !== null) {
          $video.play();
        } else if (intersectionRatio <= 0 && $video !== null) {
          $video.pause();
        }
      });
    },
    options
  );

  $videoBlocks
    .each(function () {
      videoBlockObserver.observe(this);
    });

  $(document).on('click', '.video-hero-block', function (e) {
    const $this = $(this),
          $video = $this.find('video'),
          $source = $video.find('source');

    if ($(e.target).hasClass('btn-outline-primary')) {
      return;
    }

    if ($this.hasClass('loop')) {
      if (!$this.hasClass('toggled')) {
        $source.attr('src', $source.data('full'));
        $video[0].load();
      }

      $video.prop('muted', false);

      if ($video.attr('data-show-controls') === 'true') {
        $video.prop('controls', true);
      }

      $this
        .removeClass('loop')
        .addClass('full toggled')
        .closest('.trend-video-header-wrap')
        .addClass('video-playing');

      setTimeout(() => {
        $video[0].play();
      }, 10);
    } else if ($this.hasClass('full')) {
      $video.prop('controls', false);
      $video.prop('muted', true);
      $this
        .removeClass('full')
        .addClass('loop')
        .closest('.trend-video-header-wrap')
        .removeClass('video-playing');

      $this.find('.video-cursor').removeClass('near-controls');

      setTimeout(() => {
        $video[0].pause();
      }, 10);
    }
  });


  $videoBlocks
    .mousemove(function (e) {
      const $this = $(this);
      var cursor = $this.find('.video-cursor');
      const offset = $this.offset();
      var top = e.pageY - offset.top;
      var left = e.pageX - offset.left;
      const height = $this.height();

      if ($this.hasClass('full') && top > height * 0.75) {
        cursor.addClass('near-controls');
      } else {
        cursor.removeClass('near-controls');
      }

      cursor
        .css({
          'transform': 'translate(-50%, -50%) translate3d(' + left + 'px, ' + top + 'px, 0) scale(1)'
        });
    })
    .mouseenter(function (e) {
      $(this)
        .find('.video-cursor')
        .addClass('active');
    })
    .mouseleave(function (e) {
      $(this)
        .find('.video-cursor')
        .removeClass('active near-controls');
    });

  $('.video-hero-block .btn')
    .each(function () {
      const $this = $(this);
      const $cursor = $this.closest('.video-hero-block').find('.video-cursor');

      $this
        .mouseenter(function () {
          $cursor.removeClass('active');
        })
        .mouseleave(function () {
          $cursor.toggleClass('active');
        });
    });
})();